type Input = {
  key: string
}

export const tryReadFromLocalStorage = ({ key }: Input): string | null => {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.error('Error reading item from localStorage', error, key)
    return null
  }
}
